<div class="pedido-itens-modal-lotes">
  <div class="form-row">
    <div class="form-group col-sm-12">
      <label><b>Produto:</b></label>

      <input class="form-control form-control-sm" type="text" name="produto_lote" [value]="produtoSelecionado == null ? '' : produtoSelecionado.name" disabled />
    </div>
  </div>

  <hr class="mt-2 mb-2" />

  <div class="table-responsive pedido-itens-modal-lotes-grid">
    <table class="table table-sm table-hover pedido-itens-modal-lotes-tabela">
      <thead>
        <tr>
          <th>Nome</th>
          <th class="text-center tabela_borda">Estoque</th>
          <th class="text-center tabela_borda">Validade</th>
          <th class="text-right tabela_borda">Unitário: R$</th>
        </tr>
      </thead>

      <tbody>
        @for (produtoLote of lotes; track produtoLote) {
          <tr class="tabela_linha_acao" (click)="loteSelecionado.emit(produtoLote.id)">
            <td data-label="Nome">{{ produtoLote.nomelote }}</td>
            <td class="text-center tabela_borda" data-label="Estoque">{{ produtoLote.estoque }}</td>
            <td class="text-center tabela_borda" data-label="Validade">{{ produtoLote.validade | date: 'dd/MM/yyyy' }}</td>
            <td class="text-right tabela_borda" data-label="Unitário: R$">{{ produtoLote.preco | currency: 'BRL' }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
